import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import './motion.css';
export var maskMotion = {
  motionAppear: true,
  motionName: 'maskMotionMobile'
};
export var motion = function motion(placement) {
  return {
    motionAppear: true,
    motionName: "panelMotionMobile-".concat(placement)
  };
};
export var motionProps = {
  maskMotion: maskMotion,
  motion: motion
};
export var SWIPE_DIRECTION_TO_POSITION_MAP = {
  Right: 'right',
  Left: 'left',
  Up: 'top',
  Down: 'bottom'
};
export var POSITION_TO_SWIPE_DIRECTION_MAP = Object.fromEntries(Object.entries(SWIPE_DIRECTION_TO_POSITION_MAP).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return [value, key];
}));
export var DRAWER_CLOSING_TIMEOUT = 300;